<template>
  <v-row v-show="isPhotoTaken">
    <v-col style="text-align: center">
      <canvas ref="canvas" style="display:none;" />
      <img :src="imageSrc" v-show="isPhotoTaken" style="max-width: 600px" />
    </v-col>
  </v-row>
</template>

<script>
import { GetPhoto } from "@/store/registration";

export default {
  name: "UserImage",

  props: {
    code: String,
    serviceId: String
  },

  data: () => ({
    errorMessage: "",
    imageSrc: "",
    isPhotoTaken: false
  }),

  watch: {
    code() {
      if (5 === this.code.length) {
        GetPhoto(this.serviceId, this.code)
          .then(submissions => {
            if (submissions.photo) {
              this.imageSrc = submissions.photo;
              this.isPhotoTaken = true;
            } else {
              this.imageSrc = "";
              this.isPhotoTaken = false;
            }
          })
          .catch(err => (this.errorMessage = "GetCheckinData Error: " + err));
      } else {
        this.imageSrc = "";
        this.isPhotoTaken = false;
      }
    }
  }
};
</script>
